<template>
  <div>
    <!-- desktop -->
    <div class="footer hidden-sm-and-down">
      <v-layout align-center row justify-center>
        <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>

        <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toNewTab()">API</a></b></p>

        <p style="padding-left: 20px; padding-right: 20px;color: black;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>

        <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/policy')" >นโยบาย</a></b> |</p>

        <p class="CSChatThai" style="padding-left: 5px;color: black;"><b><a style="color: black;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
      </v-layout>
    </div>
    <!-- mobile -->
    <div class="footermobile hidden-md-and-up">
      <v-layout align-center column justify-center>
        <v-flex xs12 md12>
          <v-layout align-center row justify-center>
            <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toPage('/about')">เกี่ยวกับเรา</a></b> |</p>

            <p class="CSChatThai" style="text-align: right; padding-right: 5px;color: black;"><b><a style="color: black;" @click="toNewTab()">API</a> |</b></p>

            <p class="CSChatThai" style="padding-left: 0px;color: black;"><b><a style="color: black;" @click="toPage('/policy')" >นโยบาย</a> |</b></p>

            <p class="CSChatThai" style="padding-left: 5px;color: black;"><b><a style="color: black;" @click="toPage('/contactus')" >ติดต่อเรา</a></b></p>
          </v-layout>
        </v-flex>
        <v-flex xs12 md12>
          <p style="padding-left: 20px; padding-right: 20px; color: black;"><b>&copy; {{ new Date().getFullYear() }} One Centric Company Limited</b></p>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script type="text/javascript">
  export default {
    data () {
      return {
        snackbar: false,
        textsnackbar: 'ดาวน์โหลดแอปพลิเคชัน One Chat',
        deviceos: '',
        webdev: process.env.WEBchatdev
      }
    },
    methods: {
      toNewTab () {
        window.open(this.webdev, '_blank').focus()
      },
      linkAPI () {
        window.open('/docs', '_blank').focus()
      },
      toPage (page) {
        this.$router.push(page)
      },
      linkregister () {
        window.open('/register').focus()
      },
      linkdownload () {
        window.open('/download').focus()
      },
      downloadios () {
        window.open('https://itunes.apple.com/th/app/onechat/id1394435274?mt=8').focus()
      },
      downloadandroid () {
        window.open('https://play.google.com/store/apps/details?id=com.oneplatform.android.onechat').focus()
      },
      closedownload () {
        this.snackbar = false
      }
    },
    created () {
      const device = require('current-device').default
      this.deviceos = device.os
      // console.log(this.deviceos)
      this.snackbar = true
    }
}
</script>

<style type="text/css" scoped>
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
a:link {
    text-decoration: none;
    color: white !important;
}

a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color: #2562af !important;
    text-decoration: none;
}

a:active {
    color: white !important;
    text-decoration: none;
}
.footer {
   /*position: fixed;*/
   /*height: 10vh;*/
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: white !important;
   color: white;
   text-align: center;
}
.footermobile {
   /*position: fixed;*/
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: white !important;
   color: white;
   text-align: center;
}
>>> div.typed-element {
  display: flex;
  align-items: center;
  justify-content: center;
}
  .btn-2 {
    letter-spacing: 0;
}

.btn-2:hover,
.btn-2:active {
  letter-spacing: 5px;
}

.btn-2:after,
.btn-2:before {
  backface-visibility: hidden;
  border: 1px solid rgba(#fff, 0);
  bottom: 0px;
  content: " ";
  display: block;
  margin: 0 auto;
  position: relative;
  transition: all 280ms ease-in-out;
  width: 0;
}

.btn-2:hover:after,
.btn-2:hover:before {
  backface-visibility: hidden;
  border-color: #fff;
  transition: width 350ms ease-in-out;
  width: 70%;
}

.btn-2:hover:before {
  bottom: auto;
  top: 0;
  width: 70%;
}
#particles-js {
  color: #fff;
  /*position: absolute;*/
  width: 100%;
  height: 100%;
  background-color: #000;
  /*background-image: url('/static/image/coding3.jpg');*/
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
}

$text: #fff;
$link: #e34234;
$link-hover: #ba160c;
$background: #00356B;

canvas {
  display: block;
  vertical-align: bottom;
}

#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  background: $background
}

.text {
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%,-50%);
  color: $text;
  width: 100%;
  padding: 2em 3em;
  /*background: rgba(0, 0, 0, 0.4);*/
  /*text-shadow: 0px 0px 2px #131415;*/
  font-family: 'CS ChatThaiUI' !important;
}
.textmo {
  position: absolute;
  top: 45%;
  right: 50%;
  transform: translate(50%,-50%);
  color: $text;
  width: 100%;
  padding: 2em 3em;
  /*background: rgba(0, 0, 0, 0.4);*/
  /*text-shadow: 0px 0px 2px #131415;*/
  font-family: 'CS ChatThaiUI' !important;
}
h1 {
  font-size: 2.25em;
  font-weight: 700;
  letter-spacing: -1px;
}

a,
a:visited {
  color: $link;
  transition: 0.25s;
}

a:hover,
a:focus {
  color: $link-hover;
}
</style>


// WEBPACK FOOTER //
// src/components/homepage/Footer.vue